/** 결재 진행 중 문서에 공통으로 내려오는 플래그 */
export interface ApprovalPendingFields {
  approvalInProgress?: boolean | null;
  pendingApprovalRequestId?: number | null;
  canCancelApproval?: boolean | null;
}

export function isApprovalInProgress(row?: ApprovalPendingFields | null): boolean {
  return Boolean(row?.approvalInProgress);
}

/** 기존 상태 라벨 위에 결재 요청 중을 우선 표시 */
export function withApprovalPendingLabel(
  baseLabel: string,
  approvalInProgress?: boolean | null
): string {
  if (approvalInProgress) return '결재 요청 중';
  return baseLabel;
}

/** CSS 상태 클래스: pending 우선 */
export function withApprovalPendingClass(
  baseClass: string,
  approvalInProgress?: boolean | null
): string {
  if (approvalInProgress) return 'pending';
  return baseClass;
}
